import { Sport } from "../../redux/slices";
import { PlayBase } from "./generic-play";

export enum SoccerPitchView {
  FULL = "FULL",
  LEFT_HALF = "LEFT_HALF",
  RIGHT_HALF = "RIGHT_HALF",
  LEFT_QUARTER = "LEFT_QUARTER",
  RIGHT_QUARTER = "RIGHT_QUARTER",
}

export interface SoccerPlay extends PlayBase<SoccerPitchView> {
  sport: Sport.SOCCER;
  outOfBounds: boolean;
}
